import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import Logo from '../Logo';
import { HeaderTitle } from './styles';

const Brand = () => {
  return (
    <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
      <Logo />
      <HeaderTitle data-testid="header-title">
        iets'ene Designs
      </HeaderTitle>
    </Box>
  );
};

export default Brand;